<template>
    <v-container class="px-4 pa-2 background-2" fluid >
        <v-card class="flex pa-0 round-card background-2 elevation-0">
            <v-card-title class="pa-3">
                <p>Prodotti</p>
            </v-card-title>
            <v-divider></v-divider>
            <v-data-table
                ref="childproductstask"
                class="round-card background-2"
                :headers="infoData.fieldDefs"
                :items="model.products"
                hide-default-footer
                disable-pagination
                disable-sort>
                <template v-slot:item="props">
                    <tr class="cursor-pointer" style="height: 80px;" :key="props.index">
                        <template>
                            <td :class="'text-xs-left'">
                                {{ props.index +1 }}
                            </td>
                            <td style="width: 91px; white-space: nowrap;">
                                <v-btn icon class="mx-0" @click.stop="editTaskProduct(props.index)">
                                    <v-icon color="teal">edit</v-icon>
                                </v-btn>
                                <v-btn icon class="mx-0" @click.stop="deleteTaskProduct(props.index)">
                                    <v-icon color="pink">delete</v-icon>
                                </v-btn>
                            </td>
                            <td>
                                <v-autocomplete v-if="editIndex == props.index"
                                    class="mb-n6"
                                    :items="fieldsset_products.options"
                                    item-disabled="barred"
                                    :label="fieldsset_products.label"
                                    v-model="props.item"
                                    small-chips
                                    return-object
                                    deletable-chips
                                    outlined
                                    dense
                                    cache-items
                                    :error-messages="errors.collect('Prodotto'+props.item.id)"
                                    v-validate="'required'"
                                    :data-vv-name="'Prodotto'+props.item.id" 
                                    data-vv-as="Prodotto"
                                    :filter="(item, queryText, itemText) => $eventBusUtility.customFilter(item, queryText, itemText, ['code', 'subtitle', 'barcode'])"
                                    :search-input.sync="searchProduct"
                                    @change="selectChange(props.index, $event)">
                                    <template
                                        v-slot:item="data">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                            <v-list-item-subtitle><span v-for="(key, k) in ['code', 'subtitle', 'barcode']" :key="k">{{$trans(data.item[key])}}&nbsp;</span></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                    <template v-slot:no-data>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title v-if="searchProduct && !!!fieldsset_products.searching">
                                                    Nessun risultato per "<strong>{{ searchProduct }}</strong>".
                                                </v-list-item-title>
                                                <v-list-item-title v-else>
                                                    Cerca...
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-autocomplete>
                                <span v-else>
                                    {{ printProductName(props.index) }}
                                </span>
                            </td>
                            <td style="max-width: 200px">
                                <v-text-field v-if="editIndex == props.index" 
                                    class="mb-n6"
                                    type=text
                                    label='Prezzo'
                                    v-model.number="props.item['price']"
                                    :error-messages="errors.collect('Prezzo'+props.item.id)"
                                    v-validate="'required'"
                                    :data-vv-name="'Prezzo'+props.item.id" 
                                    data-vv-as="Prezzo"
                                    outlined
                                    dense
                                ></v-text-field>
                                <span v-else>
                                    {{ props.item['price'] | currency }}
                                </span>
                            </td>
                            <td style="max-width: 200px">
                                <v-text-field v-if="editIndex == props.index" 
                                    class="mb-n6"
                                    type=text
                                    label='Quantità'
                                    v-model.number="props.item['quantity']"
                                    :error-messages="errors.collect('Quantità'+props.item.id)"
                                    v-validate="'required'"
                                    :data-vv-name="'Quantità'+props.item.id" 
                                    data-vv-as="Quantità"
                                    outlined
                                    dense                                    
                                ></v-text-field>
                                <span v-else>
                                    {{ props.item['quantity'] }}
                                </span>
                            </td>
                            <td v-if="fieldsset.fields && fieldsset.fields[3]">
                                <v-autocomplete v-if="editIndex == props.index"
                                    class="mb-n6"
                                    :items="fieldsset_warehouses.options"
                                    item-disabled="barred"
                                    :label="fieldsset_warehouses.label"
                                    v-model="props.item['warehouse_id']"
                                    small-chips
                                    deletable-chips
                                    outlined
                                    dense
                                    @change="selectWarehouseChange(props.index, $event)">
                                    <template
                                        v-slot:item="data">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                            <v-list-item-subtitle>{{$trans(data.item.text)}}&nbsp;</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                                <span v-else>
                                    {{ printWarehouseName(props.index) }}
                                </span>
                            </td>
                        </template>
                    </tr>
                </template>
            </v-data-table>
            <v-divider></v-divider>
            <v-fab-transition>
                <v-btn
                    @click="addTaskProduct()"
                    color="primary"
                    dark
                    small
                    bottom
                    left
                    fab
                    >
                    <v-icon>add</v-icon>
                </v-btn>
            </v-fab-transition>
        </v-card>
    </v-container>
</template>

<script>
    import Vue from 'vue'

    export default {
		name: "products-task",

        props: {
            model: Object,
            companyId: Number
        },

		data() {
			return {
                saved: false,
                fieldsset: [],
                infoData: {},
                fieldsset_products: [],
                fieldsset_warehouses: [],
                editIndex: null,
                searchProduct: ''
			}
        },
        
        created() {
            this.axios.get('producttask-info').then(response => {
                
                this.fieldsset = response.data.fields
                this.fieldsset_products = this.fieldsset.fields[0]
                this.fieldsset_warehouses = this.fieldsset.fields[3] ? this.fieldsset.fields[3] : []
                this.infoData = response.data.info

                this.$store.commit('endProgress')

            }, response => {
                    // error callback
            });
        },

        watch: {
			searchProduct: {
				handler(oldVal, newVal) {
                    this.$eventBusUtility.asyncSearch(this.fieldsset_products, this.searchProduct)
				}
			}
		},

        computed: {

            printProductName(index) {
                return (index) => {
                    if(this.products[index]['text']) {
                        return this.products[index]['text']
                    } else ''
                }
            },
            
            printWarehouseName(index) {
                return (index) => {
                    if(this.products[index]['warehouse']) {
                        return this.products[index]['warehouse']
                    } else ''
                }
            },

            productsById() {
                if(this.model.products.options) {
                    return this.model.products.options.reduce((obj, product) => {
                        obj[product.value] = product
                        return obj 
                    }, {})
                } else {
                    return {}
                }
            },

            products() {
                return this.model.products
            },
        },

        methods: {

            selectChange(index, event) {
                if(event) {
                    this.axios.get('products/' + event.value  + '?company_id=' + this.companyId).then(response => {
                        Vue.set(this.model.products[index], 'price',  response.data.models.product.price)
                        Vue.set(this.model.products[index], 'text',  response.data.models.product.name)
                        Vue.set(this.model.products[index], 'value',  response.data.models.product.id)
                        Vue.set(this.model.products[index], 'code',  response.data.models.product.code)
    
                    }, response => {
                        // error callback
                    })
                }
            },
            
            selectWarehouseChange(index, event) {
                if(event) {
                    let warehouse = this.fieldsset_warehouses.options.find(option => event == option.value)
                    Vue.set(this.model.products[index], 'warehouse',  warehouse.text)
                }
            },

            addTaskProduct() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }
                    if(!_.has(this.model, 'products')) {
                        Vue.set(this.model, 'products', [])
                    }
                    this.model.products.push({}) 
                    this.editIndex = this.model.products.length - 1

                }).catch(() => {

                })
            },

            editTaskProduct(index) {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }

                    if(this.editIndex == index) {
                        this.editIndex = 0
                    } else {
                        this.editIndex = index
                    }
                    
                    let option = this.model.products[this.editIndex]
                    if(typeof option.text === 'undefined' && this.model.products[this.editIndex].text) {
                        option.text = this.model.products[this.editIndex].value
                        option.value = this.model.products[this.editIndex].text
                    }
                    Vue.set(this.fieldsset_products, 'options', [option])
                }).catch(() => {

                })
            },

            deleteTaskProduct(index) {
                this.model.products.splice(index, 1)
            },
        },
    }
</script>

<style>

</style>
